import ReactTableGeneric from "Components/ReactTableGeneric";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useGebruikerContext } from "../../Context/GebruikerContext";

const Verzoeken = () => {
	const { userDetails, fetchUserDetails } = useGebruikerContext();
	const data = userDetails?.requestList;

	const columns = useMemo(
		() => [
			{
				header: () => "Id",
				accessorKey: "iSubstitutionId",
				cell: (value) => (
					<Link
						className="cursor-pointer"
						target="_blank"
						to={`/verzoeken/overzicht/${value.row.original.iSubstitutionId}`}
					>
						{value.getValue()}
					</Link>
				),
			},
			{
				header: () => "Organisatie",
				accessorKey: "vOrgName",
			},
			{
				header: () => "School",
				accessorKey: "vSchoolName",
			},
			{
				header: () => "Datum verzoek",
				accessorKey: "dAddedByDir",
			},
			{
				header: () => "1e Dag verzoek",
				accessorKey: "vSubsDate",
			},
		],
		[]
	);

	return (
		<>
			{userDetails?.profileList?.isSubstitutor && (
				<Card className="main-card">
					<CardBody>
						<Row>
							<Col className=" col-12 profile-table">
								<div className="d-flex justify-content-between">
									<h5>Verzoeken</h5>
									<span
										className={`secondary-link ${data?.length > 0 ? "cursor-pointer" : "color-grey"
											}`}
										onClick={() =>
											data?.length > 0 && fetchUserDetails("limit=all")
										}
									>
										Alles bekijken
									</span>
								</div>


								<div style={{ maxHeight: "300px", overflowY: "auto" }}>
									<ReactTableGeneric
										key={data?.length}
										data={data || []}
										columns={columns}
										tableClassName="mb-0 table table-borderless table-sm table-hover wtf-table download-table"
										filters={{
											search: false,
											sorting: false,
											pagination: false,
										}}
										rowCount={data?.length}
									/>
								</div>
							</Col>
						</Row>
					</CardBody>
				</Card>
			)}
		</>
	);
};

export default Verzoeken;
